/*=========================================================================================
  File Name: moduleRegionsMutations.js
  Description: Regions Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {

    ADD_ITEM(state, item) {
        state.regions_detailed.unshift(item)
    },

    SET_REGIONS(state, regions) {
        state.regions = [];

        for (let i = 0; i < regions.length; i++) {
            let region = {
                value: regions[i].id,
                text: regions[i].title
            };

            state.regions.push(region)
        }
    },


    SET_REGION_TRANSLATIONS(state, data) {
        state.region_translations = data.translations;
    },


    SET_REGION_INSTITUTIONS(state, institutions) {
        state.region_institutions = [];

        for (let i = 0; i < institutions.length; i++) {
            let region = {
                value: institutions[i].id,
                text: institutions[i].title,
                regionId: institutions[i].regionId
            };

            state.region_institutions.push(region)
        }
    },

    SET_REGIONS_DETAILED(state, regions) {
        state.regions_detailed = [];
        for (let i = 0; i < regions.length; i++) {
            let region = {
                id: regions[i].id,
                title: regions[i].title,
            };

            let institutions = [];
            for (let j = 0; j < regions[i].institutions.length; j++) {
                let info = {
                    id: regions[i].institutions[j].id,
                    institution: regions[i].institutions[j].title,
                    accounts: regions[i].institutions[j].accountCount,
                    indexes: regions[i].institutions[j].indexCount,
                    contacts: regions[i].institutions[j].contactCount,
                    riskGroups: regions[i].institutions[j].riskGroupCount,
                };
                institutions.push(info);
            }

            region["institutions"] = institutions;
            state.regions_detailed.push(region)
        }
    },
}
